import { makeStyles } from '@material-ui/core/styles';

export const styles = (theme) => ({
  side: {
    width: theme.sizes.sideColumn
  },
  content: {
    width: theme.sizes.contentColumn
  },
  docTitle: {
    maxWidth: 470,
    paddingLeft: 32
  },
  fileNameHeader: {
    paddingLeft: 32,
    paddingRight: 12,
    width: '24%',
    fontSize: 12
  },
  documentTypeHeader: {
    paddingLeft: 12,
    paddingRight: 12,
    width: '22%',
    fontSize: 12
  },
  policyHeader: {
    paddingLeft: 12,
    paddingRight: 12,
    width: '18%',
    fontSize: 12
  },
  lastUpdateHeader: {
    paddingLeft: 12,
    paddingRight: 12,
    width: '15%',
    fontSize: 12,
    whiteSpace: 'nowrap'
  },
  // Internal Documents text cells: `maxWidth: 0` (not a pixel cap, which a table cell ignores for its
  // content-based minimum width) lets the cell shrink to its header's percentage width and ellipsize
  // its nowrap span. Otherwise a long value — an LOE's policy ID — widens the column, the table
  // outgrows the card, and the rightmost row actions (rename, delete) are clipped off-screen (#36636).
  docTitleCell: {
    paddingLeft: 32,
    paddingRight: 12,
    maxWidth: 0,
    overflow: 'hidden'
  },
  documentTypeCell: {
    paddingLeft: 12,
    paddingRight: 12,
    maxWidth: 0,
    overflow: 'hidden'
  },
  policyCell: {
    paddingLeft: 12,
    paddingRight: 12,
    maxWidth: 0,
    overflow: 'hidden'
  },
  lastUpdateCell: {
    paddingLeft: 12,
    paddingRight: 12,
    maxWidth: 120,
    whiteSpace: 'nowrap'
  },
  truncatedText: {
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontSize: 12
  },
  smallText: {
    fontSize: 12,
    lineHeight: 1.3,
    display: 'block',
    whiteSpace: 'normal',
    wordWrap: 'break-word'
  },
  notSpecifiedText: {
    fontStyle: 'italic',
    color: theme.colorPalette.beige_75
  },
  removeButton: {
    width: 40,
    padding: 6
  },
  removeIcon: {
    width: '100%'
  },
  highlighted: {
    fontWeight: 500
  },
  noDocs: {
    padding: 12,
    textAlign: 'center'
  },
  firstCell: {
    paddingLeft: 32
  },
  docSection: {
    '& td, th': {
      padding: '4px 10px 4px 10px'
    }
  },
  modalText: {
    paddingBottom: 32
  },
  btnContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingTop: 32
  },
  btn: {
    width: '25%'
  },
  iconContainer: {
    display: 'flex'
  },
  rowActions: {
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center'
  },
  // Trim the default 12px IconButton padding so the view/rename/delete actions sit
  // in one horizontal row instead of wrapping in the narrow action column.
  rowActionButton: {
    padding: 6
  },
  rowActionIcon: {
    height: 24,
    width: 24
  },
  regularDocsTableContainer: {
    position: 'relative',
    backgroundColor: theme.colorPalette.beige_25,
    padding: '14px 32px 0px'
  },
  datePicker: {
    width: '125px',
    marginLeft: '10px',
    marginRight: '14px'
  },
  filterButton: {
    width: '85px',
    marginRight: '100px'
  },
  cantUploadContainer: {
    alignItems: 'center',
    borderTop: `solid 4px ${theme.colorPalette.orange_50}`,
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(6),
    textAlign: 'center'
  },
  cantUpload: {
    fontSize: 16,
    fontWeight: 600,
    color: theme.colorPalette.green_80
  },
  support: {
    color: theme.colorPalette.green_80
  },
  previewImagesButton: {
    fontSize: 14,
    fontWeight: 600,
    padding: 0
  },
  previewImagesIcon: {
    marginLeft: theme.spacing(2)
  }
});

export default makeStyles(styles);
